/**
 * Module:	Sign In Dialog for Periscope
 * Title:	Main
 */

import {newPage, supportedBrowsers} from '@alias_root/src/framework/page';
import {getPlatformInfo} from '@alias_root/src/framework/ods/platform';
import {tooltip} from '@alias_root/src/framework/UiTooltip';
import {getUrlParameter} from '@alias_root/src/framework/ods/url';
import {DomElement} from '@alias_root/src/framework/ods/DomElement';
import {openUserPasswordChange} from '@alias_root/src/components/passwordchange';
import {restartApplication} from '@alias_root/src/framework/errorhandler';
import {userPasswordForgottenEvent} from '@alias_root/src/components/passwordforgotten';
import {TC} from './text';
import './index.scss';

/*
 *	inputcheck
 */
function addSubmitValidation(element: string) {
	$(element).on('submit', function (event) {
		const errormsg = TC.errormsg;
		const errorcn = 'validerror ui-state-error';
		const errorcnSelector = '.validerror';
		let valid = true;

		const target = event.currentTarget;
		if (target) {
			const form = $(event.currentTarget); // Use event.currentTarget instead of 'this'
			form.find(errorcnSelector).remove();
			form.find('.required').each((_, elem) => {
				const requiredField = $(elem);
				const parent = requiredField.parent();
				const inputfield = parent.find('input');

				if (requiredField.val() === '') {
					const msg = requiredField.attr('title') || errormsg;
					const errorSpan = $(`<span class="${errorcn}">${msg}</span>`).appendTo(parent).fadeIn('fast');

					errorSpan.on('click', () => {
						errorSpan.remove(); // Remove the error span when clicked
					});

					inputfield.on('click focus', () => {
						parent.find(errorcnSelector).remove();
					});

					valid = false;
				}
			});
		}

		return valid;
	});
}

/*
 * getBrowserListHtml
 */
function getBrowserListHtml(): string {
	return `<div class="browserlistOverview">${supportedBrowsers
		.map(
			(browser) =>
				`<div class="browseritem"><div class="icon icon_${browser.id}"></div><div class="name">${browser.title}</div><div class="version">${browser.version}+</div></div>`,
		)
		.join('')}</div>`;
}

/*
 * checkCapsLock
 */
function checkCapsLock(passwordInput: DomElement) {
	const capslockInfo = new DomElement('.capslock_info', false);
	if (capslockInfo.size() === 1) {
		passwordInput.addEventListener('blur', function () {
			capslockInfo.addClass('hidden');
		});

		passwordInput.addEventListener('keypress', function (el, event) {
			const isMac = /Mac/.test(navigator.platform);
			const keyCode = event.keyCode || event.which;
			// Is the _Shift_ key pressed?
			const shiftKey = event.shiftKey || keyCode === 16;

			// Get the pressed character
			if (keyCode && !shiftKey) {
				const s = String.fromCharCode(keyCode);
				const capsLockOn =
					(s.toUpperCase() === s && s.toLowerCase() !== s && !(shiftKey && isMac)) || (s.toUpperCase() !== s && s.toLowerCase() === s && shiftKey);

				capsLockOn ? capslockInfo.removeClass('hidden') : capslockInfo.addClass('hidden');
			} else {
				capslockInfo.addClass('hidden');
			}
		});
	}
}

/*
 * userLoginCancelEvent
 */
function userLoginCancelEvent(): void {
	$('.logincancel').off('click');
	$('.logincancel').on('click', () => {
		restartApplication();
	});
}

/*
 *	render
 */
async function render() {
	addSubmitValidation('#signInForm');

	// get browser information
	const browserInfo = getPlatformInfo();

	// set 'mobile version'
	$('#theMobile').prop('checked', browserInfo.mobile);

	// Tooltip
	const $el = new DomElement('.browserlist_element').getJQueryElement();
	tooltip($el, getBrowserListHtml());

	// agency selection
	const $agency = new DomElement('select[name="theAgencyID"]').getJQueryElement();

	// user code input
	const $user = new DomElement('input[name="theUserCode"]').getJQueryElement();

	// events
	$agency.on('change', () => $user.trigger('focus'));

	// password input
	const passwordInput = new DomElement('[name="thePassword"]', false);
	if (passwordInput.size() === 1) {
		checkCapsLock(passwordInput);

		const eyeIcon = new DomElement('.signin_icon_eye');
		eyeIcon.setAttr('title', TC.eyeIconTitle);
		eyeIcon.addEventListener('click', (element) => {
			const type = passwordInput.getAttr('type');
			if (type === 'password') {
				element.addClass('passwordvisible');
				passwordInput.setAttr('type', 'text');
			} else {
				element.removeClass('passwordvisible');
				passwordInput.setAttr('type', 'password');
			}
		});
	}

	// bind click event for login cancellation
	userLoginCancelEvent();

	// bind click event for password forgotten
	userPasswordForgottenEvent();

	// open password change dialog if password is expired
	const urlParameterErrorCode = getUrlParameter('theErrorCode');
	if (urlParameterErrorCode !== null && urlParameterErrorCode === '-8') {
		await openUserPasswordChange();
	}
}

/*
 *	open a new page
 */
newPage(render);
